import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { PrivateHat } from 'src/layout/private-hat';
import { StaffCategory, Subject, SUBJECT_TITLE_TRANSLATION_KEY } from 'src/features/feedback';
import { routes } from 'src/constants/routes';
import { SubjectIcon } from 'src/features/feedback/components/subject-list/parts/subject-icon';
import { SubjectItem } from 'src/features/feedback/components/subject-list/parts/subject-item';

export const FeedbackStaffPage: FC = () => {
    const { t } = useTranslation();
    const staffCategories = Object.values(StaffCategory);

    return (
        <Fragment>
            <PrivateHat
                title={t(SUBJECT_TITLE_TRANSLATION_KEY[Subject.Staff])}
                backIconText={t('back_cta')}
            />

            <Stack padding={{ xs: '16px', md: '40px' }} alignItems={{ md: 'center' }}>
                <Typography
                    variant="h2"
                    color="text.primary"
                    marginTop={{ xs: '40px', md: '60px' }}
                    textAlign="center"
                >
                    {t('feedback_page_select-staff_description')}
                </Typography>

                <Stack padding={{ xs: '26px 0', md: '40px 0' }} width="100%" maxWidth="700px">
                    {staffCategories.map((category) => {
                        const link = routes.feedback.staff.category.replace(
                            ':staffCategory',
                            category
                        );

                        return (
                            <SubjectItem
                                key={category}
                                icon={<SubjectIcon subject={Subject.Staff} />}
                                titleKey={t(`feedback_page_select-staff_${category}`).toUpperCase()}
                                link={link}
                                css={({ palette }) => ({
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    '&:not(:last-of-type)': {
                                        borderBottom: `1px solid ${palette.divider}`,
                                    },
                                })}
                            />
                        );
                    })}
                </Stack>
            </Stack>
        </Fragment>
    );
};
